import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { EditorialListTitleFragmentDoc } from './EditorialListTitle.fragment';
export type LinkedListFragment = {
	__typename: 'GenericTitleList';
	id: string;
	content: { __typename?: 'GenericTitleListContent'; name: string };
	followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any } | null;
	titles: {
		__typename?: 'GenericTitleListConnection';
		totalCount: number;
		pageInfo: {
			__typename?: 'PageInfo';
			endCursor: string;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
			startCursor: string;
		};
		edges?: Array<{
			__typename?: 'GenericTitleListEdge';
			data: {
				__typename?: 'TitleListEntryData';
				overrides?: Array<{
					__typename?: 'TitleListEntryDataOverride';
					languageOrLocale: string;
					shortDescription?: string | null;
					title?: string | null;
					titleHeaderImage?: { __typename?: 'ArticleImage'; url: string; altText: string } | null;
				}> | null;
			};
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							shortDescription?: string | null;
							posterUrl?: string | null;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						};
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						offers?: Array<{
							__typename?: 'Offer';
							id: string;
							currency?: string | null;
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							retailPrice?: string | null;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							package: { __typename?: 'Package'; shortName: string; id: string };
						}>;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						seenState: { __typename?: 'ShowSeenState'; progress: number; seenEpisodeCount: number };
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							shortDescription?: string | null;
							posterUrl?: string | null;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						};
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						offers?: Array<{
							__typename?: 'Offer';
							id: string;
							currency?: string | null;
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							retailPrice?: string | null;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							package: { __typename?: 'Package'; shortName: string; id: string };
						}>;
				  };
		}> | null;
	};
};

export const LinkedListFragmentDoc = gql`
	fragment LinkedList on GenericTitleList {
		id
		__typename
		content(country: $country, language: $language) {
			name
		}
		followedlistEntry {
			createdAt
		}
		titles(country: $country, first: $first, filter: $filter, sortBy: NATURAL, after: $after) {
			totalCount
			pageInfo {
				endCursor
				hasNextPage
				hasPreviousPage
				startCursor
			}
			edges {
				data {
					overrides {
						titleHeaderImage {
							url
							altText
						}
						languageOrLocale
						shortDescription
						title
					}
				}
				node {
					...EditorialListTitle
				}
			}
		}
	}
	${EditorialListTitleFragmentDoc}
`;
